import { userService } from "../services/user.service";
import { tagService } from "../services/tag.service";

import { appConstants, months } from "../helpers/constants";
import currency from "../helpers/currencies.json";

export const tagActions = {
    fetchTags,
    // searchTransactions,
};


function fetchTags(obj) {
  return (dispatch, getState) => {
    dispatch({
      type: appConstants.REQUESTING,
    });
    tagService.getTagList(obj).then(
      (response) => {
        if(response.data.status == 200){
            
          dispatch({
            type: appConstants.UPDATE_TAG_LIST,
            tags: response.data.result,
          });
        }
        else {
          alert(response.data.message);
          dispatch({
            isLoggedIn: false,
            type: appConstants.ERROR_OCCURED,
            error: response.data.message
          });  
        }
        
      },
      (error) => {
        dispatch({
            isLoggedIn: false,
          type: appConstants.ERROR_OCCURED,
          error,
        });
      }
    ).catch(err=>{
      dispatch({
        isLoggedIn: false,
        type: appConstants.ERROR_OCCURED,
        err,
      });
  });
  };
}